﻿// PRE JS
import 'core-js/stable';
import 'regenerator-runtime/runtime';

// MAIN JS
import '../../Components/Pages/BookingFlowPage/Scripts/BookingFlowPage';